import { css } from "styled-components";

export const Color = {
  black: "#000",
  secondaryBlack: "#333",
  mainColor: "#CC001B",
  grey: "#555555",
  secondaryGrey: "#888",
  white: "#fff",
  yellow: "#FFC036",
  yellow2: "  #FDDF37",
  yellow3: '#D4AF37',
  greyF5F5F5:"#F5F5F5",
  greyE2E2E2:"#E2E2E2",
  grey606060: "#606060",
  grey707070: "#707070",
  greyC2C2C2: "#C2C2C2",
  lightGrey: "#cfcfcf",
  secondarylightGrey: "#dedede",
  backColor: "#dbecef",
  linkColor: "#d80026",
  secondaryColor: "#191919",
  tertiaryColor: "#d1d1d1",
  tagBkg: "#656565",
  famaColor: "#fcecdf",
  specialColor: "#F8F5F0",
  econimicColor: "#F2DECE",
  grey888: "#888",
  degreeColor: "#f15a24",
  degreeColortwo: "#29abe2",
  searchCityColor: "#ebeff1",
  greyC9: "#c9c9c9",
  grey666: "#666666",
  grey999: "#999999",
  weatherGray: "#ebebeb",
  grey777:"#777",
  greyf1f1f1:"#f1f1f1",
  black000: "#000",
  greySeparator: "#E0E0E0",
  greyCurrency: "#A3A3A3",
  green: '#448812',
  negativeCurrency: "#2cb213",
  lineColor: "#E0E0E0",
  golden : "#8f7e27",
  grey3c3c3c:  "#3c3c3c",
  infra: "#FDDF37",
  // colores agregados para estadisticas
  mainHover: "#5e7818",
  lighterGrey:"#f7f7f7",
  black0E121B:"#0E121B",
  greyE8E9EA: "#E8E9EA",
  textDarkEstadistica: "#DCDCDC",
  bordeEstadistica: "#DCDBDC",
  bgNota: "#FBF7F0",
};

//acá se definen los colores para el modo oscuro
export const ColorDark = {
  mainColor:"#FF0F3B",
  grey: "#6B6B6B",
  darkGrey:"#292929",
  greySeparator:"#424242",
  backDarknew:"#212121",
  backDarknew2:"#252525",
  textLight:"#b3b3b3",
};


export const backBanner = css`
background-color: #ebebeb;
background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
  @media (max-width: 1024px) {
    [data-theme='dark'] & {
      background-color: var(--background-color);
    }
  }
`


